export const IS_COMPATIBLE = !!window.MediaRecorder

export class MicRecorder {
  private destroyed = false
  private stream: MediaStream | null = null
  private mediaRecorder: MediaRecorder | null = null
  private audio: HTMLAudioElement | null = null
  private audioObjectURL: string | null = null
  private chunks: Blob[] = []

  constructor (private deviceId?: string | null) {
  }

  private handleData = (event: BlobEvent) => {
    this.chunks.push(event.data)
  }

  record = () => new Promise<boolean>(async (res) => {
    this.chunks = []

    const deviceId = this.deviceId
    const constraints = {
      ...deviceId ? { audio: { deviceId }} : {},
      ...!deviceId ? { audio: true } : {},
    }

    let stream: MediaStream | null = null
    try {
      stream = this.stream = await navigator.mediaDevices.getUserMedia(constraints)
    } catch (e) {}

    if (!stream) {
      res(false)
      return
    }

    if (this.destroyed) {
      this.stopStream()
      res(false)
      return
    }

    const mediaRecorder = this.mediaRecorder = new MediaRecorder(stream)
    mediaRecorder.addEventListener('dataavailable', this.handleData)

    const handleStart = () => {
      mediaRecorder.removeEventListener('start', handleStart)
      res(true)
    }
    mediaRecorder.addEventListener('start', handleStart)
    mediaRecorder.start()
  })

  private stopStream = () => {
    const stream = this.stream
    if (!stream) {
      return
    }
    stream.getTracks().forEach((track) => track.stop())
  }

  stopRecord = () => new Promise<void>(async (res: () => void) => {
    const mediaRecorder = this.mediaRecorder
    if (!mediaRecorder || mediaRecorder.state !== 'recording') {
      res()
      return
    }

    const handleStop = () => {
      mediaRecorder.removeEventListener('stop', handleStop)
      mediaRecorder.removeEventListener('dataavailable', this.handleData)
      this.stopStream()
      res()
    }
    mediaRecorder.addEventListener('stop', handleStop)
    mediaRecorder.stop()

  })

  play = () => new Promise<void>(async (res: () => void) => {
    const audioBlob = new Blob(this.chunks)
    const audioUrl = this.audioObjectURL = URL.createObjectURL(audioBlob)

    const audio = this.audio = new Audio(audioUrl)
    const handleEnd = () => {

      audio.removeEventListener('ended', handleEnd)
      audio.removeEventListener('pause', handleEnd)

      this.destroyAudio()

      res()
    }
    audio.addEventListener('ended', handleEnd)
    audio.addEventListener('pause', handleEnd)
    audio.play()
  })

  private destroyAudio = () => {
    if (this.audioObjectURL) {
      URL.revokeObjectURL(this.audioObjectURL)
      this.audioObjectURL = null
    }
  }

  destroy = () => {
    this.destroyed = true

    if (this.audio) {
      this.audio.pause()
      this.audio = null
    }

    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop()
    }
    this.mediaRecorder = null

    this.stopStream()

    this.chunks = []
    this.destroyAudio()
  }
}
